// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Rxjs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// 3rd party imports
import { plainToClass } from 'class-transformer';
import dxPopover from 'devextreme/ui/popover';

// Constant imports
import { URLConstants } from '../../_constants/url-constants';

// Model imports
import { SecurityInfoResultDto } from '../_models/security-info-result-dto';

@Injectable({
    providedIn: 'root'
})
export class SecurityInfoService {
    indicatorInstance: dxPopover;

    constructor(private readonly httpClient: HttpClient) {}

    getApiUriSecurityInfo(uri: string, action: 'GET' | 'POST' | 'PUT' | 'DELETE'): Observable<SecurityInfoResultDto> {
        const urlWithParams = `${URLConstants.ccUserBaseApiUrl}/uri/securityinfo?uri=${uri}&action=${action}`;
        return this.getSecurityInfo(urlWithParams);
    }

    getAccessCodeSecurityInfo(accessCode: string): Observable<SecurityInfoResultDto> {
        const urlWithParams = `${URLConstants.ccUserBaseApiUrl}/action/securityinfo?actionCode=${accessCode}`;
        return this.getSecurityInfo(urlWithParams);
    }

    getConfigSecurityInfo(name: string, category: string): Observable<SecurityInfoResultDto> {
        const urlWithParams = `${URLConstants.ccUserBaseApiUrl}/config/securityinfo?name=${name}&category=${category}`;
        return this.getSecurityInfo(urlWithParams);
    }

    private getSecurityInfo(urlWithParams: string): Observable<SecurityInfoResultDto> {
        return this.httpClient
            .get(urlWithParams)
            .pipe(map((response: any) => plainToClass(SecurityInfoResultDto, response)));
    }
}
